import { CarouselSwiperItemData } from "manifest-components/src/Carousel/constant";
import formatCurrency from "manifest-components/src/utils/formatCurrency";
import NextGenImage from "manifest-components/src/Images/NextGenImage";

import Meredith from "./images/meredith.jpg";
import Taylor from "./images/taylor.jpg";
import Aditi from "./images/aditi.jpg";
import Graham from "./images/graham.jpg";
import MeredithWebp from "./images/meredith.webp";
import TaylorWebp from "./images/taylor.webp";
import AditiWebp from "./images/aditi.webp";
import GrahamWebp from "./images/graham.webp";

import GoogleLogo from "./images/employer-carousel-logos/google-logo.png";
import JPMLogo from "./images/employer-carousel-logos/jpm-logo.png";
import UICLogo from "./images/employer-carousel-logos/university of chicago-logo.png";
import oracleLogo from "./images/employer-carousel-logos/oracle-logo.png";
import unitedLogo from "./images/employer-carousel-logos/united-logo.png";
import ipgLogo from "./images/employer-carousel-logos/ipg-logo.png";

export const slidesInfo: CarouselSwiperItemData[] = [
  {
    image: <NextGenImage alt="Meredith" src={Meredith} srcWebp={MeredithWebp} />,
    title: `Meredith CONSOLIDATED INTO`,
    consolidatedInto: "Her 401(k) with Vanguard",
    savingsDisplay: formatCurrency(5574),
    quote:
      "I’m very impressed with Manifest. Instead of having to worry about looking for documents, figuring out how transfers work, or troubleshooting issues on my own, Manifest took care of my transfer for me.",
  },
  {
    image: <NextGenImage alt="Taylor" src={Taylor} srcWebp={TaylorWebp} />,
    title: "Taylor CONSOLIDATED",

    consolidatedInto: "Her old 401(k) at Interpublic Group",
    savingsDisplay: formatCurrency(15835),
    quote:
      "This is amazing. The app helped me complete a task that's been on my to-do list for 3 years, in 30 minutes!",
  },
  {
    image: <NextGenImage alt="Graham" src={Graham} srcWebp={GrahamWebp} />,
    title: "Graham CONSOLIDATED INTO",
    consolidatedInto: "His 401(k) at Beam Suntory",
    savingsDisplay: formatCurrency(1303),
    quote:
      "Manifest's expertise with transfers simplified the entire process for me and led to a seamless and efficient transfer of my retirement savings.",
  },
  {
    image: <NextGenImage alt="Aditi" src={Aditi} srcWebp={AditiWebp} />,
    title: "Aditi CONSOLIDATED",
    consolidatedInto: "Her old 401(k) with Fidelity",
    savingsDisplay: formatCurrency(25642),
    quote:
      "I almost lost my old account forever. Manifest’s support, convenience, and transparency helped me maximize my retirement savings every step of the way.",
  },
];

export const logoSlidesInfo = [
  {
    alt: "Google",
    src: GoogleLogo,
  },
  {
    alt: "J.P Morgan",
    src: JPMLogo,
  },
  {
    alt: "University of Chicago",
    src: UICLogo,
  },
  {
    alt: "Oracle",
    src: oracleLogo,
  },
  {
    alt: "United Airline",
    src: unitedLogo,
  },
  {
    alt: "IPG",
    src: ipgLogo,
  },
];

export const testimonies = [
  {
    content:
      "I’m very impressed with Manifest. Instead of having to worry about looking for documents, figuring out how transfers work, or troubleshooting issues on my own, Manifest took care of my transfer for me.",
    name: "Meredith",
    subtitle: "consolidated with Vanguard",
  },
  {
    content:
      "This is amazing. The app helped me complete a task that's been on my to-do list for 3 years, in 30 minutes!",
    name: "Taylor",
    subtitle: "consolidated at Interpublic Group",
  },
  {
    content:
      "Manifest's expertise with transfers simplified the entire process for me and led to a seamless and efficient transfer of my retirement savings.",
    name: "Graham",
    subtitle: "consolidated at Beam Suntory",
  },
  {
    content:
      "I almost lost my old account forever. Manifest’s support, convenience, and transparency helped me maximize my retirement savings every step of the way.",
    name: "Aditi",
    subtitle: "consolidated with Fidelity",
  },
];
